import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';

interface GetQuantifyWhereClauseOptions {
  shouldIncludeDashboardFilters?: boolean;
}

export const useGetQuantifyWhereClause = ({
  shouldIncludeDashboardFilters = true,
}: GetQuantifyWhereClauseOptions = {}) => {
  return useQuantifyStore(({ query, visual }) => {
    return shouldIncludeDashboardFilters
      ? visual.quantifyAndDashboardFilters.whereClause ??
          query.whereClause ??
          EmptyWhereClause
      : query.whereClause ?? EmptyWhereClause;
  });
};
